import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  ButtonGroup,
  HStack,
  IconButton,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { FaPen, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteBoxTemplate,
  getBoxesTemplates,
} from '../../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';
import DeleteAlert from '../../Alerts/DeleteAlert';
import BoxList from './BoxList';

const TemplateList = ({ setToUpdate, onOpen }) => {
  const { boxTemplates } = useSelector(state => state.boxTemplates);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const cancelRef = useRef();
  const toast = useToast();
  const dispatch = useDispatch();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteBoxTemplate({ id: selectedTemplate?.id }));

    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'boxTemplate/deleteBoxTemplate/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      dispatch(getBoxesTemplates());
      setSelectedTemplate(null);
      toast({
        description: 'Template has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <React.Fragment>
      <Accordion defaultIndex={0} allowToggle>
        {boxTemplates.map(box => (
          <AccordionItem key={box.id}>
            {({ isExpanded }) => (
              <React.Fragment>
                <HStack
                  spacing={0}
                  backgroundColor={isExpanded ? 'primaryOpaque' : 'none'}
                  _hover={{ background: 'primaryOpaque', color: 'primary' }}
                >
                  <AccordionButton
                    _expanded={{ color: 'primary', fontWeight: 'bold' }}
                    _hover={{ background: 'none' }}
                  >
                    <Box flex="1" textAlign="left">
                      {box.name}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <ButtonGroup spacing={'1'}>
                    <IconButton
                      aria-label="Edit"
                      icon={<FaPen />}
                      variant={'outline'}
                      size="sm"
                      color={'primary'}
                      onClick={() => {
                        setToUpdate({
                          state: true,
                          template: box,
                        });
                        onOpen();
                      }}
                    />
                    <IconButton
                      aria-label="Delete"
                      icon={<FaTimes />}
                      variant={'outline'}
                      size="sm"
                      color={'red.400'}
                      onClick={() => {
                        setSelectedTemplate(box);
                        onOpenAlert();
                      }}
                    />
                  </ButtonGroup>
                </HStack>
                <AccordionPanel pb={4}>
                  <BoxList
                    boxes={box.goal_category_templates}
                    templateId={box.id}
                  />
                </AccordionPanel>
              </React.Fragment>
            )}
          </AccordionItem>
        ))}
      </Accordion>
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete this template?`}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever."
        }
        onDeleteItem={onDeleteItem}
      />
    </React.Fragment>
  );
};

export default TemplateList;
